import { createSvgIcon } from '@mui/material';
import Styled from './custom-styled-icon';

export const ArrowUpTwo = Styled(
	createSvgIcon(
		<svg
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M2.72003 10.0333L7.0667 5.68667C7.58003 5.17334 8.42003 5.17334 8.93336 5.68667L13.28 10.0333'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeMiterlimit='10'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>,
		'ArrowUpTwo'
	)
);

export default ArrowUpTwo;
